// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import SinglePostTemplatePage from "../templates/SinglePostTemplate/SinglePostTemplate";
const __wvcRoutePaths = ["/post/post/:post_id"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutmepage", "coursesseminarspage", "energyflowyogapage", "homepage", "impressum", "imprintpage", "kurse-seminare", "ourstudiopage", "post", "qi-gong-yoga", "qi-gong-yoga2", "qigongandyogapage", "qigongyogapage", "startseite", "training-im-einklang", "traininginharmonypage", "uber-mich", "unser-studio", "was-ist-tai-chi", "whatistaichipage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<SinglePostTemplatePage />} />
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
